import { database } from "../../config/firebase";

export const fetchCurrentStudentGroup = groupKey => dispatch => {
  dispatch({ type: "FETCHING_STUDENT_GROUP" });
  const ref = database.ref("groups");
  ref
    .orderByChild("key")
    .equalTo(groupKey)
    .on("value", function(snapshot) {
      dispatch({ type: "FETCHED_STUDENT_GROUP", payload: snapshot.val() });
    });
};

export const createStudentsGroup = (
  studentKeys,
  nombreGrupo,
  nivel,
  identificadorNivel,
  colegio
) => dispatch => {
  dispatch({ type: "CREATING_STUDENT_GROUP" });

  const key = database
    .ref()
    .child("groups")
    .push({
      studentIds: studentKeys,
      nombreGrupo,
      nivel,
      identificadorNivel,
      colegio
    })
    .getKey();

  database
    .ref()
    .child("groups")
    .child(key)
    .update({ key });

  database
    .ref()
    .child("users")
    .once("value")
    .then(() => {
      studentKeys.forEach(x => {
        database
          .ref()
          .child("users")
          .child(x)
          .update({ groupKey: key });
      });
    });
};

export const removeStudentFromGroup = (studentId, groupId) => (
  dispatch,
  getState
) => {
  const group = getState().groups.allGroups.byId[groupId];

  database
    .ref("groups")
    .child(groupId)
    .set({
      ...group,
      studentIds: group.studentIds.filter(id => id !== studentId)
    })
    .then(() =>
      dispatch({
        type: "REMOVE_STUDENT_FROM_GROUP",
        payload: { studentId, groupId }
      })
    )
    .catch(error => console.log("remove student error", error));

  database
    .ref("users")
    .child(studentId)
    .set({
      ...getState().users.allUsers.byId[studentId],
      groupKey: ""
    })
    .then(() =>
      dispatch({
        type: "REMOVE_GROUPKEY_FROM_STUDENT",
        payload: { studentId, groupId }
      })
    )
    .catch(error => console.log("remove student error", error));
};

export const deleteStudentGroup = groupKey => () => {
  database
    .ref()
    .child("groups")
    .child(groupKey)
    .on("value", function(snapshot) {
      const group = snapshot.val() || [];
      group.studentIds &&
        group.studentIds.forEach(x => {
          database
            .ref()
            .child("users")
            .child(x)
            .update({
              groupKey: null
            });
        });

      database
        .ref()
        .child("groups")
        .child(groupKey)
        .remove();
    });
};

export const editGroupAction = (groupId, values) => dispatch => {
  dispatch({
    type: "UPDATE_GROUP_USERS",
    payload: { groupId, userIds: values.studentIds }
  });
  database
    .ref("groups")
    .child(groupId)
    .set({ ...values })
    .then(() => console.log("check group id"));

  values.studentIds.forEach(userId => {
    database
      .ref("users")
      .child(userId)
      .update({ groupKey: groupId });
    dispatch({ type: "UPDATE_USER_GROUP", payload: { groupId, userId } });
  });

  database.ref("users").once("value", usersSnapshot => {
    usersSnapshot.forEach(userSnapshot => {
      const user = userSnapshot.val();
      if (user.groupKey && !values.studentIds.includes(user.key)) {
        database
          .ref("users")
          .child(user.key)
          .update({ groupKey: "" });
      }
    });
  });
};

export const fixStudentIds = () => dispatch => {
  const respuestasRef = database.ref("respuestas");
  const preguntasRef = database.ref("preguntas");
  const groupsRef = database.ref("groups");
  const usersRef = database.ref("users");

  dispatch({ type: "FIXING_STUDENT_GROUPS" });

  groupsRef.once("value", groupsSnapshot => {
    groupsSnapshot.forEach(groupSnapshot => {
      const group = groupSnapshot.val();
      if (group.studentIds) {
        group.studentIds.map(studentId => {
          usersRef.child(studentId).once("value", userSnapshot => {
            const user = userSnapshot.val();
            usersRef
              .child(studentId)
              .set({
                ...user,
                groupKey: group.key,
                nombreGroupo: group.nombreGrupo
              })
              .then(x =>
                console.log(
                  "añadido",
                  `${userSnapshot.val().nombre} a ${
                    groupSnapshot.val().nombreGrupo
                  }`
                )
              );
          });
        });
      }
    });
  });
};
